<template>
  <div class="news">
    <div class="row" v-if="arrs.length">
      <router-link
        :to="'/detail/' + item.id + '?type=notify'"
        v-for="(item, index) in arrs"
        :key="index"
        class="margin-bottom-20 col-md-12"
      >
        <div class="newslist">
          <div class="date"><span></span>{{ item.publishTime }}</div>
          <div class="news-content">
            <div class="title">{{ item.title }}</div>
            <div class="article">{{ item.description }}</div>
          </div>
          <div class="author">发布者: {{ item.author }}</div>
        </div>
      </router-link>
    </div>
    <div v-else style="width: 100%; text-align: center">
      <h2>无通知公告</h2>
    </div>
    <!-- <div class="text-center margin-bottom-20">
    <div class="page">
      <button class="btn btn-default margin-right-10" :class="{'active':activenum === 0}" type="submit" @click="primaryPage" >首页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="prePage" :class="{'active':activenum === 1}">上页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="nextPage" :class="{'active':activenum === 2}">下页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="lastPage" :class="{'active':activenum === 3}">尾页</button>
      <button class="btn btn-default" type="submit" style="background: none">{{current_page}}/{{Math.ceil(arrs.length/pagesize)}}</button>
    </div>
  </div> -->
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  props: {
    arrs: Array
  },
  data: function () {
    return {
      currentPage: 1, // 当前页号
      activenum: 0, // 每页大小
      pagesize: 5
    }
  },
  computed: {
    page_arrs () {
      let {currentPage, pagesize} = this
      return this.arrs.slice(
        (currentPage - 1) * pagesize,
        currentPage * pagesize
      )
    },
    current_page () {
      return this.currentPage
    },
  },
  methods: {
    primaryPage () {
      this.currentPage = 1
      this.activenum = 0
    },
    prePage () {
      if (this.currentPage === 1) {
        this.activenum = 1
        return
      }
      this.currentPage = this.currentPage - 1
      this.activenum = 1
    },
    nextPage () {
      if (this.currentPage === Math.ceil(this.arrs.length / this.pagesize)) {
        return
      }
      this.currentPage = this.currentPage + 1
      this.activenum = 2
    },
    lastPage () {
      this.currentPage = Math.ceil(this.arrs.length / this.pagesize)
      this.activenum = 3
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.news {
  background: #fff;
  padding: 20px 28px;
}

.newslist {
  margin-bottom: 20px;

  a {
    color: #333;
  }

  .author {
    font-size: 14px;
    color: #999;
  }

  .col-md-9 {
    border-right: 1px dashed #efefef;
  }

  .col-md-3 {
    text-align: center;

    .date {
      font-size: 30px;
    }

    .year {
      color: #999;
    }
  }
}

.btn {
  width: 80px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  background: #cbccce;
  text-align: center;
  color: #fff;
  border: none;
}

.active {
  background: $bgColor;
}

.date {
  color: #666;
}

.date span {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: $bgColor;
  border-radius: 4px;
  margin-right: 10px;
}

.news-content {
  border: 1px solid #efefef;
  margin-top: 20px;
  padding: 20px;
  margin-bottom: 20px;

  &:hover {
    -webkit-box-shadow: 0px 0px 10px #999;
    box-shadow: 0px 0px 10px #999;
  }

  .title {
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    ellipsis2();
    color: #333;
    margin-bottom: 10px;
  }

  .article {
    line-height: 22px;
    color: #999;
    ellipsis3();
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/notice/components/NewsList.vue